// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Gcf6m","employee-header-item":"Header_employee-header-item__cCnjE"};